module.exports = __webpack_public_path__ + "media/images/flags/ws-a5bc5f0894f19e3903ddbfb3c1748415.svg";